import React from "react";
import FieldNoteWrap from "./FieldNoteWrap";

function FieldNote() {
  return (
    <section className="fieldnote-page section-bottom-pad">
      <FieldNoteWrap />
    </section>
  );
}

export default FieldNote;
